export default "__VITE_ASSET__DE$5wr0p__"